import URL from 'url';

import EventRateCounter from '@ad-scripts/application/actions/lib/event_rate_counter';
import MqttClient from '@ad-scripts/infrastructure/backends/mqtt_client';

const MAX_DISCONNECT_COUNT = 5;
const DISCONNECT_INTERVAL_THRESHOLD = 30000; // Sliding time window (ms) used for counting disconnects

export default function createMqttClient(clientId: string) {
  const url = URL.format({
    protocol: getProtocol(),
    slashes: true,
    hostname: window.location.hostname,
    port: window.location.port,
    pathname: '/edge',
  });

  const rateCounter = new EventRateCounter(MAX_DISCONNECT_COUNT, DISCONNECT_INTERVAL_THRESHOLD);
  const mqtt = new MqttClient({ eventRecorder: null, url, clientId });
  mqtt.on('disconnect', () => {
    rateCounter.countEvent();
    if (rateCounter.isExcessive) {
      rateCounter.reset();
      mqtt.emit('disconnect-rate-limit');
    }
  });

  return mqtt;
}

function getProtocol() {
  return window.location.protocol.replace(/^http/, 'ws');
}
